import { render, staticRenderFns } from "./DetailDeliveryOrder.vue?vue&type=template&id=3217176c&scoped=true&"
import script from "./DetailDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./DetailDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeliveryOrder.vue?vue&type=style&index=0&id=3217176c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217176c",
  null
  
)

export default component.exports